/**
 * Checkbox Component
 *
 * A reusable checkbox component that follows the StartupHive design system.
 *
 * Props:
 * - label: string - label text (required)
 * - id: string - checkbox id (required for accessibility)
 * - name: string - checkbox name
 * - checked: boolean - controlled checkbox state
 * - onChange: function - change handler
 * - disabled: boolean
 * - className: additional CSS classes for wrapper
 * - ...rest: any other input attributes
 */

function Checkbox({
  label,
  id,
  name,
  checked,
  onChange,
  disabled = false,
  className = '',
  ...rest
}) {
  return (
    <div className={`form-checkbox ${className}`.trim()}>
      <input
        type="checkbox"
        id={id}
        name={name || id}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="checkbox"
        {...rest}
      />
      <label htmlFor={id} className="checkbox-label">
        {label}
      </label>
    </div>
  )
}

export default Checkbox
